import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type LockedSectionProps = {
  items: ReactNode[];
  className?: string;
};

export function LockedSection({ items, className }: LockedSectionProps) {
  if (!items.length) {
    return null;
  }
  return (
    <section className={cn("space-y-4", className)}>
      <div className="mx-auto flex w-full max-w-6xl items-center gap-3 text-xs uppercase tracking-[0.3em] text-muted-foreground">
        <span className="h-px flex-1 bg-background/40" />
        Locked
        <span className="h-px flex-1 bg-background/40" />
      </div>
      <div className="mx-auto grid w-full max-w-6xl gap-4 md:grid-cols-2">{items}</div>
    </section>
  );
}

type UnlockedSectionProps = {
  title?: string;
  description?: string;
  children: ReactNode;
  className?: string;
};

export function UnlockedSection({ title, description, children, className }: UnlockedSectionProps) {
  return (
    <section className={cn("space-y-3", className)}>
      {title && (
        <div className="space-y-1">
          <p className="text-xs uppercase tracking-wide text-amber-400">{title}</p>
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
      )}
      {children}
    </section>
  );
}
